// Module 19 (BL-380) G9a - Guest Transport reads and the one write. Both are checked database functions (migration 245): the caller's
// own organization, the Events pack, the Events area at the event's brand, Dispatch rights at the transportation company, MFA.
// Nothing here confirms, prices, assigns or sends anything: a trip starts as 'requested' and Dispatch takes it from there.

// True when the functions do not exist yet (code live minutes before migration 245 is applied): the section then stays hidden.
export function missingTransportFunction(error) {
    const text = `${error?.code || ''} ${error?.message || ''}`;
    return /PGRST202|42883/.test(text) || (/m19_(guest_transport|request_guest_transport)/.test(text) && /does not exist|schema cache|Could not find/.test(text));
}

// The event's Guest Transport section, or null when it cannot be shown (not applied yet, or an unexpected answer).
export async function loadGuestTransport(client, engagementId) {
    const { data, error } = await client.rpc('m19_guest_transport', { p_event_id: engagementId });
    if (error) {
        if (missingTransportFunction(error)) return null;
        throw error;
    }
    if (!data || typeof data !== 'object' || !Array.isArray(data.trips) || typeof data.dispatchEnabled !== 'boolean') return null;
    return data;
}

export async function requestGuestTransport(client, engagementId, requestId, fields) {
    const { data, error } = await client.rpc('m19_request_guest_transport', { p_event_id: engagementId, p_request: requestId, p_fields: fields });
    if (error) throw error;
    if (!data?.ok || !data?.tripId) throw new Error('The trip request could not be confirmed. Refresh to check before trying again.');
    return data;
}

// Database wording -> plain English for the popup. The function's own messages are already plain; anything else gets a safe line.
export function friendlyTransportError(error) {
    const text = `${error?.message || ''}`;
    if (missingTransportFunction(error)) return 'Guest Transport is not available yet. Please try again in a few minutes.';
    if (/row-level security|permission denied/.test(text)) return 'You do not have permission to request guest transport.';
    if (error?.code === '22023' || error?.code === '42501' || error?.code === 'P0002') return text;
    return text || 'The trip could not be requested. Please try again.';
}
